<template>
    <div class="h-100 white">
        <c-dms-documents
            :step-data-id = "collectionId"
            :bid-id       = "bidId"
            :step-name    = "bidName"
            :documents    = documents
            :compact      = "true"
            category     = "repairService"
        />
    </div>
</template>

<script>

// DOCimport Inc from "@/modules/inc/service/Inc";
import CDmsDocuments from "@/modules/dms/menu/components/CDmsDocuments.vue";

export default {
    name: "IncBidDocuments",
    components: {
        CDmsDocuments,
    },

    props: {
        bidId: {
            required: false,
            type: Number
        },

        bidName: {

        },

        data: {

        },

        collectionId: {
            required: true,
            type: Number
        },
    },

    data: () => ({
        menu: false,
    }),

    computed: {
        documents () {
            if (!this.data) {
                return null;
            }

            return this.data.documents.filter(d => this.bidId && d.bidId === this.bidId);
        },
    },

    created() {
        this.$bus.$on("inb-doc-deached", this.onRemoved);
        this.$bus.$on(this.$events.refreshdocuments, this.load);
    },

    beforeDestroy() {
        this.$bus.$off("inb-doc-deached", this.onRemoved);
        this.$bus.$off(this.$events.refreshdocuments, this.load);
    },

    methods: {
        load () {
            if (!this.collectionId) {
                return;
            }

            if (!this.bidId) {
                return;
            }
        },

        count () {
            return this.documents.length;
        },

        onRemoved (message) {
            if (!this.documents) {
                return;
            }

            const docs = this.documents.filter(d => d.id = message.dmsId);
            if (docs) {
                this.load();
            }
        }
    }
}
</script>

<style scoped>

</style>